import { render, staticRenderFns } from "./MenuItemModal.vue?vue&type=template&id=646e51aa&scoped=true&"
import script from "./MenuItemModal.vue?vue&type=script&lang=js&"
export * from "./MenuItemModal.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemModal.vue?vue&type=style&index=0&id=646e51aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646e51aa",
  null
  
)

export default component.exports